const getBusinessUnitList = (state) => state.businessUnitList

const getNpsStatementReport = (state) => state.npsStatementReport

const getNpsCountByUnitReport = (state) => state.npsCountByUnitReport

const getnpsDetailsReport = (state) => state.npsDetailsReport

const getOpHistSolByUnit = (state) => state.opHistSolByUnit

const getSolicitationByService = (state) => state.solicitationByService

const getSolicitationyStatus = (state) => state.solicitationyStatus

const getLateSolicitations = (state) => state.lateSolicitations

const getSolicitationsByUserProfile = (state) => state.solicitationsByUserProfile

const getAverageSolicitationsPerUser = (state) => state.averageSolicitationsPerUser

const getGeneralTotalSolicitationsPerUser = (state) => state.generalTotalSolicitationsPerUser

const getSolicitationsByUserPerDay = (state) => state.solicitationsByUserPerDay

const getTotalNewSolicitationsInDay = (state) => state.totalNewSolicitationsInDay

const getAvarageNewSolicitationsInPeriod = (state) => state.avarageNewSolicitationsInPeriod

const getApprovedSolicitationsByUnitInPeriod = (state) => state.approvedSolicitationsByUnitInPeriod

const getTotalUsersByProfile = (state) => state.totalUsersByProfile

const getTotalUsersByUnit = (state) => state.totalUsersByUnit

export default {
  getBusinessUnitList,
  getNpsStatementReport,
  getNpsCountByUnitReport,
  getnpsDetailsReport,
  getOpHistSolByUnit,
  getSolicitationByService,
  getSolicitationyStatus,
  getLateSolicitations,
  getSolicitationsByUserProfile,
  getAverageSolicitationsPerUser,
  getGeneralTotalSolicitationsPerUser,
  getSolicitationsByUserPerDay,
  getTotalNewSolicitationsInDay,
  getAvarageNewSolicitationsInPeriod,
  getApprovedSolicitationsByUnitInPeriod,
  getTotalUsersByProfile,
  getTotalUsersByUnit
}
